// Limit FREE LURE to one per customer
const FREE_LURE_ID = 46904721932460;

function addFreeLureOnce() {
  // Check the cart first
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const alreadyHasFreeLure = cart.items.some(
        item => item.variant_id === FREE_LURE_ID
      );

      // If customer already has one, skip adding and redirect
      if (alreadyHasFreeLure) {
        window.location.href = '/pages/573lures-6-per-lure-10-value';
        return;
      }

      // Otherwise add exactly one FREE LURE
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: FREE_LURE_ID,
          quantity: 1
        })
      })
      .then(() => {
        window.location.href = '/pages/573lures-6-per-lure-10-value';
      });
    });
}
